import { useEffect } from "react";
import { auth } from "../firebase";
import { useAppAuthState } from "./use-app-auth-state";

export function usePollForVerifiedEmail(onVerified: () => void) {
  const { unverifiedFireUser, isAuthLoading } = useAppAuthState();

  useEffect(() => {
    const interval = setInterval(() => {
      const user = auth.currentUser;
      if (user?.emailVerified) {
        onVerified();
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [unverifiedFireUser, isAuthLoading, onVerified]);
}
